import { render, staticRenderFns } from "./RegisterPersonal.vue?vue&type=template&id=761696c2&"
import script from "./RegisterPersonal.vue?vue&type=script&lang=js&"
export * from "./RegisterPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports